import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Google Translate rewrites text nodes directly in the DOM outside React's
// control. When React's reconciler later tries to remove/reorder one of
// those same nodes, the browser throws (NotFoundError: node to be removed
// is not a child of this node) and crashes the whole app. This is the
// standard community workaround: let the mismatched call no-op instead of
// throwing.
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      return child;
    }
    return originalRemoveChild.call(this, child);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return newNode;
    }
    return originalInsertBefore.call(this, newNode, referenceNode);
  };
}

// Google Translate injects its own "Translated into: X — Show original"
// banner iframe into the page and forces an inline `top: 40px` on body to
// push content down for it. Google's translate.js also injects its OWN
// stylesheet asynchronously, loaded after ours — when both rules use
// !important, the one added LAST in the document wins ties, so Google's
// can beat index.css's `!important` depending on load timing. The only
// override that reliably beats an external !important rule is an inline
// style that is ALSO !important (via setProperty(..., 'important')), so
// enforce it that way in JS, re-applied on every DOM mutation since
// Google keeps re-asserting its own styles on each language switch.
const hideGoogleTranslateBanner = () => {
  document.body.style.setProperty('top', '0px', 'important');
  document.querySelectorAll('.goog-te-banner-frame, iframe.skiptranslate').forEach((el) => {
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('height', '0', 'important');
  });
};
hideGoogleTranslateBanner();
new MutationObserver(hideGoogleTranslateBanner).observe(document.documentElement, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['style'],
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
